import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";

import {
  Container,
  SummaryWrap,
  SummaryFirst,
  BgColorDiv,
  SummaryText,
} from "./styled";
import { IsNotMobile, IsMobile } from "../../ResponsiveContainers";
import { useWindowDimensions } from "../../../hooks";

const ImgBanner = ({ title, coverImg }) => {
  const { isPad, isMobile } = useWindowDimensions();
  let imgPath = !isPad ? coverImg.desktop : coverImg.ipad;
  imgPath = isMobile ? coverImg.mobile : imgPath;
  return (
    <Container>
      <Image
        alt={`reviews banner`}
        src={imgPath}
        layout="fill"
        objectFit="cover"
        loading="lazy"
        quality={100}
      />
      <SummaryWrap>
        <IsNotMobile>
          <SummaryFirst>
            <BgColorDiv />
            <SummaryText>What our customers are saying:</SummaryText>
          </SummaryFirst>
        </IsNotMobile>
        <IsMobile>
          <SummaryFirst>
            <BgColorDiv />
            <SummaryText>What our customers</SummaryText>
          </SummaryFirst>
          <SummaryFirst>
            <BgColorDiv />
            <SummaryText>are saying:</SummaryText>
          </SummaryFirst>
        </IsMobile>
      </SummaryWrap>
    </Container>
  );
};

ImgBanner.propTypes = {
  title: PropTypes.string,
  coverImg: PropTypes.shape({
    desktop: PropTypes.string,
    ipad: PropTypes.string,
    mobile: PropTypes.string,
  }),
};

export default ImgBanner;
